import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TaxData } from '@fcp/lib-ui';

@Injectable({ providedIn: 'root' })
export class SectionTaxContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getTaxas(id: string): Observable<any> {
    return this.getTaxasContents(id).pipe(
      map(res => this.buildResponseTaxsObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryTaxasContents[0].data;
  }

  private getTaxasContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryTaxasContents(filter: "id eq '${id}'") {
          data {
            title {
              iv
            }
            description {
              iv
            }
            links {
              iv {
                description
                url
                icon {
                  url
                }
              }
            }
            icon {
              iv {
                url
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseTaxsObject(data: any) {
    let links = [];
    if (data.links && data.links.iv) {
      links = data.links.iv.map(link => {
        link.icon = link.icon && link.icon[0] ? +link.icon[0].url : '';
        return link;
      });
    }
    return {
      title: data.title ? data.title.iv : '',
      description: data.description ? data.description.iv : '',
      links,
      icon:
        data.icon && data.icon.iv && data.icon.iv[0] ? +data.icon.iv[0].url : ''
    } as TaxData;
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
